import { ErrorHandler, Injectable } from '@angular/core';



@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // alert(
    //   '⚠️ Angular Error Capturado:\n' +
    //   (error?.message || error?.toString()) +
    //   '\n\nStack:\n' + (error?.stack || 'sin stack')
    // );

    // También podrías loguearlo en consola o a un backend
    console.error('GlobalErrorHandler:', error);
  }
}

